var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Logo } from '../logo';
import { styled } from '../styled';
import { spinnerComponentName, getSpinnerUtilityClass } from './spinner-classes';
import { composeClasses } from '../styles/classes';
import clsx from '../utils/clsx';
var Root = styled('div', {
    name: spinnerComponentName,
    slot: 'Root',
})(function (_a) {
    var theme = _a.theme, ownerState = _a.ownerState;
    var sizeValue = {
        small: theme.typography.pxToRem(14),
        medium: theme.typography.pxToRem(40),
        large: theme.typography.pxToRem(60),
    }[ownerState.size || 'medium'];
    return {
        height: sizeValue,
        width: sizeValue,
        position: 'relative',
    };
});
var StyledSpinner = styled('span', {
    name: spinnerComponentName,
    slot: 'Spinner',
})(function (_a) {
    var theme = _a.theme, ownerState = _a.ownerState;
    var sizeValue = {
        small: theme.typography.pxToRem(14),
        medium: theme.typography.pxToRem(40),
        large: theme.typography.pxToRem(60),
    }[ownerState.size || 'medium'];
    return {
        height: sizeValue,
        width: sizeValue,
        '@keyframes rotate': {
            '0%': { transform: 'rotate(0deg)' },
            '100%': { transform: 'rotate(1turn)' },
        },
        display: 'inline-block',
        border: "2px solid",
        borderColor: theme.tokens.color_bg_layer_bold,
        borderLeftColor: theme.tokens.color_fg_default,
        borderRadius: '50%',
        verticalAlign: 'text-bottom',
        animation: 'rotate 0.8s infinite linear',
    };
});
var StyledLogo = styled(Logo, { name: spinnerComponentName, slot: 'Logo' })({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-48%, -50%)',
});
var useUtilityClasses = function (_a) {
    var classes = _a.classes;
    var slots = {
        root: ['root'],
        spinner: ['spinner'],
        logo: ['logo'],
    };
    return composeClasses(slots, getSpinnerUtilityClass, classes);
};
export var Spinner = React.forwardRef(function (props, ref) {
    var classes = useUtilityClasses(props);
    var _a = props.size, size = _a === void 0 ? 'small' : _a, _b = props.inverse, inverse = _b === void 0 ? false : _b, _c = props.LogoProps, LogoProps = _c === void 0 ? {} : _c, className = props.className, rootProps = __rest(props, ["size", "inverse", "LogoProps", "className"]);
    var ownerState = {
        size: size,
        inverse: inverse,
    };
    if (size === 'small') {
        return (React.createElement(StyledSpinner, __assign({ ref: ref, ownerState: ownerState, className: clsx(classes.spinner, className) }, rootProps)));
    }
    return (React.createElement(Root, __assign({ ref: ref, ownerState: ownerState, className: clsx(classes.root, className) }, rootProps),
        React.createElement(StyledSpinner, { ownerState: ownerState, className: classes.spinner }),
        React.createElement(StyledLogo, __assign({ size: size === 'medium' ? 'xsmall' : 'small', color: inverse ? 'light' : 'dark' }, LogoProps))));
});
